<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p><a id="toc">
<div class="fmh1">
    Table of Contents
  </div>
<div>
     <br/>
</div>
</a><div class="cfmh"><a id="toc">
</a><a href="#/Text/keit_9781569752777_oeb_fm1_r1">COURAGE After Fire</a>
</div>
<div class="cfmh">
<a href="#/Text/keit_9781569752777_oeb_tp_r1">Title Page</a>
</div>
<div class="cfmh">
<a href="#/Text/keit_9781569752777_oeb_frw_r1">Foreword</a>
</div>
<div class="cfmh">
<a href="#/Text/keit_9781569752777_oeb_itr_r1">Introduction</a>
</div>
<div>
     <br/>
</div>
<div class="cct">
<a href="#/Text/keit_9781569752777_oeb_c01_r1">Chapter 1 - Reactions to War</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h1">Positive Effects of War</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h2">Negative Effects of War</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h3">Anxiety</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h4">Posttraumatic Stress</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h5">Panic Attacks</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h6">Phobias</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h7">Anger</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h8">Substance Use</a>
</div>
<div class="ch1">
<a href="#/Text/keit_9781569752777_oeb_c01_r1#h9">Depression</a>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/keit_9781569752777_oeb_c02_r1" title="Link target outside of Sample">Chapter 2 - Strengthening Your Mind and Body</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c02_r1#h1" title="Link target outside of Sample">A Strengths-Oriented Approach</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c02_r1#h2" title="Link target outside of Sample">Relaxation Drills</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c02_r1#h3" title="Link target outside of Sample">Taking “Stronger” Care of Yourself</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/keit_9781569752777_oeb_c03_r1" title="Link target outside of Sample">Chapter 3 - Coping Strategies</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c03_r1#h1" title="Link target outside of Sample">Combating Posttraumatic Stress</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c03_r1#h2" title="Link target outside of Sample">Combating Panic</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c03_r1#h3" title="Link target outside of Sample">Combating Anger</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c03_r1#h4" title="Link target outside of Sample">Combating Alcohol or Drug Abuse</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c03_r1#h5" title="Link target outside of Sample">Combating Depression</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/keit_9781569752777_oeb_c04_r1" title="Link target outside of Sample">Chapter 4 - Grief and Loss</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c04_r1#h1" title="Link target outside of Sample">What Is Grief?</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c04_r1#h2" title="Link target outside of Sample">Reactions to Sudden Loss</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c04_r1#h3" title="Link target outside of Sample">Frequently Asked Questions about Grief</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/keit_9781569752777_oeb_c05_r1" title="Link target outside of Sample">Chapter 5 - Changed Views of Self, Others, and the World</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h1" title="Link target outside of Sample">Safety and Trust</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h2" title="Link target outside of Sample">Control and Power</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h3" title="Link target outside of Sample">Future Outlook</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h4" title="Link target outside of Sample">Self-Worth and Self-Esteem</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h5" title="Link target outside of Sample">Relationships and Closeness</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h6" title="Link target outside of Sample">Meaning and Purpose of Life</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h7" title="Link target outside of Sample">Spirituality and Faith</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h8" title="Link target outside of Sample">Positive Change</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c05_r1#h9" title="Link target outside of Sample">Coping with Changed Views</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/keit_9781569752777_oeb_c06_r1" title="Link target outside of Sample">Chapter 6 - Returning to Civilian Life</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c06_r1#h1" title="Link target outside of Sample">Readjusting to Work</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c06_r1#h2" title="Link target outside of Sample">Coming Home to No Job</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c06_r1#h3" title="Link target outside of Sample">Readjusting to the Community</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c06_r1#h4" title="Link target outside of Sample">“Dumb” Questions Civilians Ask and How to Respond to Them</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/keit_9781569752777_oeb_c07_r1" title="Link target outside of Sample">Chapter 7 - Restoring Family Roles and Relationships</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c07_r1#h1" title="Link target outside of Sample">Feeling a “Part” after Being Apart</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c07_r1#h2" title="Link target outside of Sample">Tips for Reuniting with Your Family</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c07_r1#h3" title="Link target outside of Sample">Talking about Your War Experiences with Supportive Adults</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c07_r1#h4" title="Link target outside of Sample">How to Talk with Supportive Adults</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c07_r1#h5" title="Link target outside of Sample">Improving Intimate Relationships</span>
</div>
<div class="ch1">
<span href="#/Text/keit_9781569752777_oeb_c07_r1#h6" title="Link target outside of Sample">Reconnecting with Children</span>
</div>
<div>
     <br/>
</div>
<div class="cbmh">
<span href="#/Text/keit_9781569752777_oeb_bm1_r1" title="Link target outside of Sample">Resources</span>
</div>
<div class="cbmh">
<span href="#/Text/keit_9781569752777_oeb_in1_r1" title="Link target outside of Sample">Index</span>
</div>
<div class="cbmh">
<span href="#/Text/keit_9781569752777_oeb_ata_r1" title="Link target outside of Sample">About the Authors</span>
</div>
<div class="cbmh">
<span href="#/Text/keit_9781569752777_oeb_ack_r1" title="Link target outside of Sample">Acknowledgements</span>
</div>
<div class="cbmh">
<span href="#/Text/keit_9781569752777_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// keit_9781569752777_oeb_toc_r1.vue?060aefce